<template>
    <ul v-if="showPagination" class="pagination m-0">
        <li
            v-if="isFirstPage"
            key="previous-disabled"
            class="page-item disabled"
            :title="$t('pagination.custom.in-first')">
            <button type="button" class="page-link" disabled>
                &lsaquo;
            </button>
        </li>

        <li v-else key="previous-page" class="page-item">
            <button
                type="button"
                class="page-link"
                :title="$t('pagination.custom.previous')"
                @click.prevent="paginate(current - 1)">
                &lsaquo;
            </button>
        </li>

        <li
            v-for="(page, index) in pages"
            :key="index"
            class="page-item"
            :class="{'disabled': pageIsFiller(page), 'active': pageIsCurrent(page)}">
            <span v-if="pageIsFiller(page)" class="page-link">
                &hellip;
            </span>

            <button
                v-else-if="pageIsCurrent(page)"
                type="button"
                class="page-link"
                :title="$t('pagination.custom.current', {page})"
                disabled>
                <span>{{ page }}</span>
            </button>

            <button
                v-else
                type="button"
                class="page-link"
                :title="$t('pagination.custom.page', {page})"
                @click.prevent="paginate(page)">
                <span>{{ page }}</span>
            </button>
        </li>

        <li
            v-if="isLastPage"
            key="next-disabled"
            class="page-item disabled"
            :title="$t('pagination.custom.in-last')">
            <button type="button" class="page-link" disabled>
                &rsaquo;
            </button>
        </li>

        <li v-else key="next-page" class="page-item">
            <button
                type="button"
                class="page-link"
                :title="$t('pagination.custom.next')"
                @click.prevent="paginate(current + 1)">
                &rsaquo;
            </button>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'CollectionPaginator',

    props: {
        current: {type: Number, required: true},
        last: {type: Number, required: true},
    },

    computed: {
        showPagination() {
            return this.current > 1 || this.last > 1;
        },

        isFirstPage() {
            return this.current === 1;
        },

        isLastPage() {
            return this.current === this.last;
        },

        pages() {
            const template = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

            if (this.last <= 11) { // is short
                return template.slice(0, this.last);
            }

            if (this.current < 7) { // close to start
                return template.slice(0, 8).concat([false, this.last - 1, this.last]);
            }

            if ((this.last - this.current) < 6) { // close to end
                const reversed = template.slice(0, 8)
                    .map((_, index) => this.last - index)
                    .reverse();

                return [1, 2, false].concat(reversed);
            }

            return [1, 2, false]
                .concat([this.current - 2, this.current - 1, this.current, this.current + 1, this.current + 2])
                .concat([false, this.last - 1, this.last]);
        },
    },

    methods: {
        paginate(page) {
            this.$emit('paginate', page);
        },

        pageIsCurrent(page) {
            return this.current === page;
        },

        pageIsFiller(page) {
            return page === false;
        },
    },
};
</script>
